import { helper } from '@ember/component/helper';
import { set as set$1 } from '@ember/object';

/**
 * Helper to set a property on an object.
 * Replacement for deprecated (mut) helper.
 * Works with both Classic components (Ember.set) and Glimmer (@tracked).
 *
 * Usage in templates:
 *   @action={{fn (set this "propertyName")}}
 *
 * When called with a value, sets obj.propertyName = value
 */
var set = helper(function ([obj, key]) {
  return function (value) {
    set$1(obj, key, value);
  };
});

export { set as default };
//# sourceMappingURL=set.js.map
